// reducer.js
import { SET_USER_SERVICES, UPDATE_USER_SERVICE } from "./actionType";

const initialState = {
  services: [], // array of { service_id, is_enabled, settings, price }
};

const userServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SERVICES:
      return {
        ...state,
        services: action.payload, // full list from API
      };

    case UPDATE_USER_SERVICE:
      return {
        ...state,
        services: state.services.map((service) =>
          service.service_id === action.payload.service_id
            ? { ...service, ...action.payload.data }
            : service
        ),
      };

    default:
      return state;
  }
};

export default userServicesReducer;
